__turbopack_context__.v({
  "ember": "RQjfla_ember",
  "root": "RQjfla_root",
});
